import React from 'react';
import clsx from 'clsx';
import { Card } from 'semantic-ui-react';
import LinkifyWrapper from '../LinkifyWrapper';

const LinkCardDescription = ({ value, className }) => (
  <Card.Description className={clsx('aridhia-link-card-description', className)}>
    <LinkifyWrapper>
      {value}
    </LinkifyWrapper>
  </Card.Description>
);

export default LinkCardDescription;
